module.exports = __webpack_public_path__ + "static/media/bolso (12).ae08a0c5.jpg";